/*
  Cele patru porți „ce vrei să îmbunătățești azi?".

  Apeși o poartă → rămân pe ecran DOAR frecvențele din grupa aia, în ordinea
  scrisă de Xenia. Apeși „Toate frecvențele" → revin toate, în ordinea din
  colecție.

  Grupele se suprapun — „Încredere" e în trei dintre ele — și e în regulă:
  o frecvență poate apărea în mai multe porți, fiindcă răspunde la mai multe
  nevoi. Ce nu apare într-o poartă apare în alta, sau la „Toate".

  Nu reîncarcă pagina și nu cere nimic serverului.

  ⚠️ Grila e carusel pe desktop și rămâne carusel. Se ascund doar săgețile cât
  timp o poartă e apăsată — n-au ce derula când sunt trei carduri. Clasele de
  carusel NU se scot: fără ele cardurile se lățesc vizibil.
*/
(function () {
  'use strict';

  var bara = document.querySelector('[data-hf-nevoi]');
  if (!bara) return;

  /* Grila țintă e prima grilă de produse de după bara de porți. N-o caut după
     id: id-urile secțiunilor conțin numărul șablonului și se schimbă când
     Shopify duplică tema. */
  var sectiuneBara = bara.closest('.shopify-section');
  var tinta = null;
  var s = sectiuneBara && sectiuneBara.nextElementSibling;
  while (s && !tinta) {
    if (s.querySelector('.product-grid')) tinta = s.querySelector('.product-grid');
    s = s.nextElementSibling;
  }
  if (!tinta) return;

  var carduri = Array.prototype.slice.call(tinta.querySelectorAll('.grid__item'));
  if (!carduri.length) return;

  var ordineInitiala = carduri.slice();
  var eraCarusel = tinta.classList.contains('slider');

  /* handle-ul fiecărui card se citește din adresa lui: Dawn nu-l pune nicăieri
     ca atribut. Adresa e codificată procentual din cauza diacriticelor. */
  carduri.forEach(function (c) {
    var a = c.querySelector('a[href*="/products/"]');
    var h = '';
    try {
      h = a ? decodeURIComponent(a.getAttribute('href')).split('/products/')[1] : '';
    } catch (e) {
      h = a ? a.getAttribute('href').split('/products/')[1] : '';
    }
    c.dataset.hfHandle = (h || '').split('?')[0].split('#')[0];
  });

  function aseaza(lista) {
    var frag = document.createDocumentFragment();
    lista.forEach(function (c) { frag.appendChild(c); });
    tinta.appendChild(frag);
    if (tinta.scrollLeft) tinta.scrollLeft = 0;
  }

  /* ⚠️ NU se ating clasele de carusel.
     Prima variantă le scotea, ca să nu rămână săgeți care nu duc nicăieri. Dar
     fără ele grila devine „4 coloane", iar cardurile se lățesc de la 286px la
     340px pe un ecran de 1400 — și mult mai mult pe unul lat. Xenia a văzut
     asta ca „se măresc foarte mult", și avea dreptate.

     Caruselul rămâne carusel. Se ascund doar săgețile și numărătoarea, care
     n-au ce număra când sunt trei carduri. */
  /* Lățimea unui card când sunt toate pe ecran. Se măsoară o singură dată, la
     pornire, și se folosește ca lățime fixă cât timp o poartă e apăsată.

     ⚠️ De ce e nevoie: în carusel cardurile au `flex: 1 0 auto`. Cu
     șaisprezece, banda dă pe dinafară și nimic nu crește. Cu trei, rămâne loc
     liber, iar `flex-grow: 1` le lățește până la `max-width` — de la 273px la
     315px. Ochiul citește asta ca „s-au mărit cardurile". */
  var latCard = 0;

  function carusel(pornit) {
    if (!eraCarusel) return;

    if (!latCard) {
      var v = carduri.filter(function (c) { return c.getBoundingClientRect().height > 0; })[0];
      if (v) latCard = Math.round(v.getBoundingClientRect().width);
    }
    if (latCard) tinta.style.setProperty('--hf-lat-card', latCard + 'px');
    tinta.classList.toggle('hf-filtrat', !pornit);

    var jur = tinta.closest('slider-component') || tinta.parentElement;
    if (!jur) return;
    ['.slider-buttons', '.slider-counter'].forEach(function (sel) {
      var e = jur.querySelector(sel);
      if (e) e.hidden = !pornit;
    });
  }

  function arataToate() {
    carduri.forEach(function (c) { c.hidden = false; c.style.display = ''; });
    aseaza(ordineInitiala);
    carusel(true);
  }

  function arataGrupa(handles) {
    var rang = {};
    handles.forEach(function (h, i) { rang[h] = i; });

    var potrivite = [];
    carduri.forEach(function (c) {
      var e = Object.prototype.hasOwnProperty.call(rang, c.dataset.hfHandle);
      c.hidden = !e;
      c.style.display = e ? '' : 'none';
      if (e) potrivite.push(c);
    });

    /* în ordinea din lista Xeniei, nu în ordinea din colecție */
    potrivite.sort(function (a, b) { return rang[a.dataset.hfHandle] - rang[b.dataset.hfHandle]; });
    aseaza(potrivite.concat(carduri.filter(function (c) { return c.hidden; })));
    carusel(false);
  }

  bara.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hf-nevoie]');
    if (!b) return;

    bara.querySelectorAll('[data-hf-nevoie]').forEach(function (x) {
      x.classList.toggle('is-activ', x === b);
    });

    if (b.dataset.hfNevoie === 'toate') {
      arataToate();
    } else {
      arataGrupa(
        (b.dataset.handles || '')
          .split(',')
          .map(function (h) { return h.trim(); })
          .filter(Boolean)
      );
    }

    /* Grila trebuie să intre în ecran: dacă porțile sunt sus și grila jos,
       omul apasă și nu vede că s-a întâmplat ceva. */
    var sus = tinta.getBoundingClientRect().top + window.scrollY - 90;
    window.scrollTo({ top: sus, behavior: 'smooth' });
  });
})();
